import { Common } from '../../../shared/Common';
import {
  appPrimaryColor,
  tooltipBackgroundColor,
  tooltipBorderBottomColor,
  tooltipBorderColor,
  tooltipBoxShadow,
  tooltipColor,
} from './colors';
import { IExpenseCategory } from './types';

interface ExpenseCategoryTooltipProps {
  active?: boolean;
  payload?: readonly any[];
  label?: string | number;
  categories: IExpenseCategory[];
  categoryOrder: number[];
  getCategoryColor: (id: number) => string;
  selectedCategoryId?: number;
  isViewingSingleCategoryWithChildren?: boolean;
  hoveredCategoryId?: number | null;
}

const ExpenseCategoryTooltip = ({
  active,
  payload,
  label,
  categories,
  categoryOrder,
  getCategoryColor,
  selectedCategoryId,
  isViewingSingleCategoryWithChildren,
  hoveredCategoryId,
}: ExpenseCategoryTooltipProps) => {
  if (active && payload && payload.length) {
    const chartPoint = payload[0].payload as {
      month: number;
      year: number;
      visibleExpense?: number;
      expenseCategories?: IExpenseCategory[];
    };
    const hasExpenseBars = payload.some(
      (item) => typeof item.graphicalItemId === 'string' && item.graphicalItemId.startsWith('recharts-bar')
    );
    const categoriesById = new Map(
      (chartPoint.expenseCategories ?? []).map((category) => [category.categoryId, category])
    );
    const usedCategories = hasExpenseBars
      ? categoryOrder
          .map((categoryId) => {
            const category = categories.find((item) => item.categoryId === categoryId);
            const catData = categoriesById.get(categoryId);
            const isParentEntry = isViewingSingleCategoryWithChildren && categoryId === selectedCategoryId;
            const value = isParentEntry ? (catData?.directCost ?? 0) : (catData?.totalCost ?? 0);
            return {
              categoryName: category?.categoryName ?? 'Brak kategorii',
              categoryId,
              value,
            };
          })
          .filter((category) => category.value > 0)
      : [];
    const totalExpenseValue = chartPoint.visibleExpense ?? payload.find((item) => item.name === 'Wydatki')?.value;
    let header = '';
    label = chartPoint.month;
    if (label!.toString().length <= 1) {
      label = '0' + label;
    }
    header = `${label}.${chartPoint.year}`;

    return (
      <div
        style={{
          backgroundColor: tooltipBackgroundColor,
          border: `1px solid ${tooltipBorderColor}`,
          borderRadius: '4px',
          padding: '8px 12px',
          boxShadow: tooltipBoxShadow,
        }}
      >
        <div
          style={{
            fontSize: '13px',
            fontWeight: 'bold',
            color: tooltipColor,
            marginBottom: '6px',
            borderBottom: `1px solid ${tooltipBorderBottomColor}`,
            paddingBottom: '4px',
          }}
        >
          {header}
        </div>
        {totalExpenseValue !== undefined && (
          <>
            <div style={{ fontSize: '12px', color: 'black', marginBottom: '3px' }}>
              <span style={{ fontWeight: '500' }}>Razem:</span>{' '}
              {Common.Utils.getCurrencyString(Number(totalExpenseValue))}
            </div>
            {usedCategories &&
              usedCategories.reverse().map((category) => {
                const isHovered = category.categoryId === hoveredCategoryId;
                return (
                  <div
                    key={category.categoryId}
                    style={{
                      fontSize: '12px',
                      color: getCategoryColor(category.categoryId),
                      marginBottom: '3px',
                      marginLeft: '5px',
                      textDecoration: isHovered ? 'underline' : 'none',
                      fontWeight: 400,
                    }}
                  >
                    <span>{category.categoryName}:</span> {Common.Utils.getCurrencyString(category.value)}
                  </div>
                );
              })}
          </>
        )}
      </div>
    );
  }
};

export default ExpenseCategoryTooltip;
